import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateKeywordStatus } from '../../../../services/monitor/keywords/KeywordsService';
import { KeywordStatus } from '../../../../models/monitor/KeywordResponse';
import { GET_PROJECT_KEYWORDS } from '../../../query/keyword/keys';
import { GET_PROJECT_ALL_BRANDS_RESPONSE, GET_PROJECT_DAILY_STATS } from '../../../query/project/stats/keys';
import { GET_KEYWORDS_DAILY_STATS_FOR_PROJECT } from '../../../query/keyword/stats/keys';

interface UpdateKeywordStatusParams {
  keywordId: number;
  status: KeywordStatus;
}

interface UseUpdateKeywordStatusOptions {
  onError?: (error: unknown) => void;
}

export const useUpdateKeywordStatus = (
  projectId: number,
  options?: UseUpdateKeywordStatusOptions
) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ keywordId, status }: UpdateKeywordStatusParams) =>
      updateKeywordStatus(keywordId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_KEYWORDS, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_ALL_BRANDS_RESPONSE, projectId],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_PROJECT_DAILY_STATS],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_KEYWORDS_DAILY_STATS_FOR_PROJECT],
      });
    },
    onError: (error: unknown) => {
      options?.onError?.(error);
    },
  });

  return mutation;
};